var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.coronavirus)?[_vm._t("covid")]:[_vm._t("current")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }